import { styled as t, Stack as e } from "@mui/joy";
import i from "@mui/material/DialogActions";
import a from "@mui/material/DialogContent";
import p from "@mui/material/DialogTitle";
import o from "@mui/material/IconButton";
const l = t(p)(({ theme: t2 }) => ({ margin: 0, padding: `${t2.spacing(1.5)} ${t2.spacing(3)}`, height: "56px", display: "flex", alignItems: "center", gap: "10px", paddingLeft: "24px", marginRight: "50px" })), m = t(o)(({ theme: t2 }) => ({ position: "absolute", right: t2.spacing(1), top: t2.spacing(1), color: t2.palette.isDarkMode ? t2.palette.neutral[600] : t2.palette.neutral[500] })), n = t(a)(({ theme: t2 }) => ({ display: "flex", flexDirection: "column", gap: t2.spacing(2) })), r = t(i)(({ theme: t2 }) => ({ padding: `${t2.spacing(1.5)} ${t2.spacing(3)}` })), g = t(e)`
  svg {
    fill: ${({ theme: t2 }) => t2.palette.isDarkMode ? t2.palette.neutral[600] : t2.palette.neutral[500]};
  }
`;
export {
  r as DialogActions,
  n as DialogContent,
  l as DialogTitle,
  m as IconButton,
  g as IconContainer
};
//# sourceMappingURL=styled.js.map
